<template>
  <MainTabEvents :main-title="mainTitle">
    <div class="main-tab__filters main-tab__filters--events">
      <div class="dea-input-container dea-input-container--events">
        <label class="dea-input-container__label dea-input-container__label--date" for="startDate">
          Seleziona una data
        </label>
        <div class="dea-input-container__inputs">
          <input
            id="startDate"
            v-model="selectedFromDateFilter"
            class="dea-input dea-input--date"
            placeholder="Seleziona Data Inizio"
            type="date"
            lang="it"
            :max="selectedToDateFilter"
            @change="handleSelectedFromDateFilter"
          />
          <input
            id="endDate"
            v-model="selectedToDateFilter"
            class="dea-input dea-input--date"
            placeholder="Seleziona Data Fine"
            type="date"
            lang="it"
            :min="selectedFromDateFilter"
            @change="handleSelectedToDateFilter"
          />
        </div>
      </div>
    </div>
    <ContentWrapper :class="contentWrapperExtraClasses">
      <template #default>
        <Loader v-if="!ordersLoaded"></Loader>
        <template v-else-if="orders.length">
          <OrderCard v-for="order in orders" :key="order.id" :order="order" type="li"></OrderCard>
        </template>
        <template v-else>
          <div class="dea-heading--medium__ml">
            Nessun corso acquistato
          </div>
        </template>
      </template>
    </ContentWrapper>
    <PurchaseInfo v-if="orders.length > 0"></PurchaseInfo>
    <PaginationBlock
      v-if="myOrdersPagination.pages.length > 1"
      :pagination="myOrdersPagination"
      @changePage="changePage"
    ></PaginationBlock>
  </MainTabEvents>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loader from "@/components/elements/Loader";
import PaginationBlock from "@/components/elements/PaginationBlock";
import OrderCard from "@/components/patterns/OrderCard"; // eslint-disable-line import/no-extraneous-dependencies
import MainTabEvents from "~/components/events/components/MainTabEvents";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import PurchaseInfo from "~/components/events/components/PurchaseInfo.vue";

export default {
  name: "EventsOrders",
  components: {
    ContentWrapper,
    Loader,
    MainTabEvents,
    OrderCard,
    PaginationBlock,
    PurchaseInfo,
  },
  data() {
    return {
      disabledFromDates: { to: new Date(2019, 0, 1) },
      disabledToDates: { to: new Date(2019, 0, 1) },
      ticketWrapperComponent: "",
      versionIndex: 0,
      preRegistrationFilter: null,
      inputSelectFilters: [
        { id: "default", name: "Tutti", value: "" },
        { id: "active", name: "Attivo", value: "active" },
        { id: "past", name: "Partecipato", value: "past" },
        { id: "notAttended", name: "Non partecipato", value: "notAttended" },
      ],
      selectedFilter: "",
      selectedFromDateFilter: undefined,
      selectedToDateFilter: undefined,
    };
  },
  computed: {
    ...mapGetters(["ticketFilter", "titles", "orders", "ordersLoaded", "myOrdersPagination"]),
    mainTitle() {
      return this.titles.main[this.ticketFilter];
    },
    contentWrapperExtraClasses() {
      if (this.ticketFilter === "ordersRecap") {
        return "content-wrapper--reduced-margin";
      }
      return "";
    },
  },
  created() {
    this.fetchOrders();
  },
  mounted() {
    this.selectedFromDateFilter = this.dateParams.created__gte;
    this.selectedToDateFilter = this.dateParams.created__lte;
  },
  methods: {
    ...mapActions(["fetchOrders"]),
    ...mapMutations(["setViewChanged", "setPage", "setFromDateFilter", "setToDateFilter"]),

    async changePage(page) {
      let newPage = page;
      if (page === "prev" && this.myOrdersPagination.has_previous) {
        newPage = this.myOrdersPagination.current - 1;
      } else if (page === "next" && this.myOrdersPagination.has_next) {
        newPage = this.myOrdersPagination.current + 1;
      } else if (page === "first" && this.myOrdersPagination.has_previous) {
        newPage = 1;
      } else if (page === "last" && this.myOrdersPagination.has_next) {
        newPage = this.myOrdersPagination.last;
      }

      if (newPage === this.myOrdersPagination.current) return;

      this.setViewChanged(true);
      this.setPage(newPage);
      await this.fetchOrders();
    },

    async handleSelectedFromDateFilter(event) {
      const {
        target: { value },
      } = event;
      this.setViewChanged(true);
      this.setPage(1);
      this.setFromDateFilter(value);
      await this.fetchOrders();
    },

    async handleSelectedToDateFilter(event) {
      const {
        target: { value },
      } = event;
      this.setViewChanged(true);
      this.setPage(1);
      this.setToDateFilter(value);
      await this.fetchOrders();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.subscription-container {
  &__paragraph {
    margin-bottom: $space-base;
    margin-top: $space-x-large;
  }
}
</style>
